<script lang="ts">
    import GraduationCapIcon from '$lib/components/foundation/icons/GraduationCapIcon.component.svelte';
    import type { MinicartItemViewModel } from '$lib/types/ecommerce';

    export let item: MinicartItemViewModel;
</script>

<div class="grid grid-cols-[1.5rem_1fr] gap-2 mb-4">
    <GraduationCapIcon />
    <div>
        <h4 class="text-base font-bold">{item.courseInfo.name}</h4>
        <p class="text-balance">
            {item.courseInfo.category}: {item.courseInfo.location},
            <wbr />
            {item.courseInfo.schedule}
        </p>
    </div>
</div>

<div class="flex justify-between items-center">
    <span class="font-bold">Antal deltagare: {item.quantity}</span>
    <span>á {new Intl.NumberFormat('sv-SE').format(item.unitPrice)} kr</span>
</div>
